import u from 'umbrellajs/umbrella.esm.js'

// Dropdown toggle handler
u('[data-dropdown-toggle]').on('click', function (e) {
  e.stopPropagation();

  const currentWrapper = this.closest('[data-dropdown-wrapper]');
  const $currentWrapper = u(currentWrapper);
  const $dropdown = $currentWrapper.find('[data-dropdown-menu]');
  const $arrow = u(this).find('.arrow');

  const wasOpen = !$dropdown.hasClass('hidden');

  // Close all dropdowns
  u('[data-dropdown-wrapper]').each(wrapper => {
    u(wrapper).find('[data-dropdown-menu]').addClass('hidden');
    u(wrapper).find('.arrow').removeClass('rotate-180');
  });

  // Reopen the clicked one if it was closed
  if (!wasOpen) {
    $dropdown.removeClass('hidden');
    $arrow.addClass('rotate-180');
  }
});

// Close desktop dropdowns when clicking outside
document.addEventListener('click', function (e) {
  u('[data-dropdown-wrapper]').each(wrapper => {
    // Only close if the click is outside this dropdown
    if (!wrapper.contains(e.target)) {
      u(wrapper).find('[data-dropdown-menu]').addClass('hidden'); // hide menu
      u(wrapper).find('.arrow').removeClass('rotate-180');        // reset arrow
    }
  });
});

// Close desktop dropdowns on window resize
window.addEventListener('resize', function () {
  u('[data-dropdown-wrapper]').each(wrapper => {
    u(wrapper).find('[data-dropdown-menu]').addClass('hidden'); // hide menu
    u(wrapper).find('.arrow').removeClass('rotate-180');        // reset arrow
  });
});

// Toggle menu
u('.mobile-toggle').on('click', function (e) {
  e.stopPropagation();
  const wrapper = u(this).parent();
  const menu = wrapper.find('.menu-dropdown');
  const iconOpen = u(this).find('.icon-open');
  const iconClose = u(this).find('.icon-close');

  const isOpen = !menu.hasClass('hidden');

  menu.toggleClass('hidden');
  iconOpen.toggleClass('hidden');
  iconClose.toggleClass('hidden');

  u(this).attr('aria-expanded', String(!isOpen));
});

// Close on mouseup outside
u(document).on('mouseup', function (e) {
  const target = u(e.target);

  const menu = u('.menu-dropdown');
  const toggle = u('.mobile-toggle');

  if (
    !target.closest('.menu-dropdown').length &&
    !target.closest('.mobile-toggle').length
  ) {
    menu.addClass('hidden');
    toggle.find('.icon-open').removeClass('hidden');
    toggle.find('.icon-close').addClass('hidden');
    toggle.attr('aria-expanded', 'false');
  }
});

// Reset mobile dropdown on resize
window.addEventListener('resize', () => {
  if (window.innerWidth >= 768) {
    u('.mobile-menu').addClass('hidden');
    u('.icon-open').removeClass('hidden');
    u('.icon-close').addClass('hidden');
  } else {
    u('.menu-dropdown').addClass('hidden');
    u('.mobile-menu').addClass('hidden');
  }
});

// Alert toggle
u('.bsk-alert-close').on('click', function () {
  const alertClose = u(this.closest('.bsk-alert'));
  alertClose.addClass('hidden');
});

// Pills click handler
const pillButtons = u('.bsk-pills .bsk-pill-btn');
pillButtons.on('click', function () {
  const pillName = this.dataset.tab;

  const $this      = u(this);
  const $pillsRoot = $this.closest('.bsk-pills-nav');
  if (!$pillsRoot.length) return;

  const $allButtons = $pillsRoot.find('.bsk-pill-btn');
  const $allPanels  = $pillsRoot.find('.bsk-pill-contents > div');

  $allButtons.attr('aria-selected', 'false');
  $this.attr('aria-selected', 'true');

  $allPanels.addClass('hidden');
  $pillsRoot.find(`#${pillName}`).removeClass('hidden');
});

// Tabs click handler
const tabButtons = u('.bsk-tabs .bsk-tab-btn');
tabButtons.on('click', function () {
  const tabName = this.dataset.tab;

  const $this      = u(this);
  const $tabsRoot = $this.closest('.bsk-tabs-nav');
  if (!$tabsRoot.length) return;

  const $allButtons = $tabsRoot.find('.bsk-tab-btn');
  const $allPanels  = $tabsRoot.find('.bsk-tab-contents > div');

  $allButtons.attr('aria-selected', 'false');
  $this.attr('aria-selected', 'true');

  $allPanels.addClass('hidden');
  $tabsRoot.find(`#${tabName}`).removeClass('hidden');
});

// Progress bar
document.addEventListener('DOMContentLoaded', () => {
  initProgressBars();
});

function initProgressBars(context = document) {
  const progressBars = u(context).find('[data-progress]');
  
  if (progressBars.length === 0) return; // Nothing to do

  progressBars.each(el => {
    const current = Number(el.dataset.current ?? 0);
    const min = Number(el.dataset.min ?? 0);
    const max = Number(el.dataset.max ?? 100);

    // Avoid division by zero
    const percent = max !== min ? Math.round(((current - min) / (max - min)) * 100) : 0;

    // Update label if it exists
    const label = el.querySelector('[data-progress-label]');
    if (label) label.textContent = `${percent}%`;

    // Update fill if it exists
    const fill = el.querySelector('[data-progress-fill]');
    if (fill) fill.style.width = `${percent}%`;

    // Update ARIA attributes if bar exists
    const bar = el.querySelector('[data-progress-bar]');
    if (bar) {
      bar.setAttribute('aria-valuenow', current);
      bar.setAttribute('aria-valuemin', min);
      bar.setAttribute('aria-valuemax', max);
    }
  });
}

// Back to Top button
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('btn-back-to-top');
  if (!btn) return;

  window.addEventListener('scroll', () => {
    //console.log('ScrollY:', window.scrollY); // Debug

    if (window.scrollY > 100) {
      btn.classList.remove('opacity-0', 'pointer-events-none');
      btn.classList.add('opacity-100', 'pointer-events-auto');
    } else {
      btn.classList.remove('opacity-100', 'pointer-events-auto');
      btn.classList.add('opacity-0', 'pointer-events-none');
    }
  });

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});

// Search Modal
const modal = u('#search-modal');

u('#open-nav-search').on('click', () => {
  modal.removeClass('hidden');
  u('body').addClass('overflow-hidden');
  const input = u('.pagefind-ui__search-input').first();
  input && input.focus();
});

// Close modal if any link inside the modal is clicked
u('#search-modal').on('click', 'a', (e) => {
    modal.addClass('hidden');
    u('body').removeClass('overflow-hidden');
    const input = u('.pagefind-ui__search-input').first();
    input.value = '';
});

// Close modal if the 'X' is clicked
u('#close-nav-search, #search-modal > div:first-child').on('click', () => {
  modal.addClass('hidden');
  u('body').removeClass('overflow-hidden');
    const input = u('.pagefind-ui__search-input').first();
    input.value = '';
});

// Optional: ESC key closes modal
u(document).on('keydown', (e) => {
  if (e.key === 'Escape') {
    modal.addClass('hidden');
    const input = u('.pagefind-ui__search-input').first();
    input.value = '';
  }
});

// import Alpine from 'alpinejs'

// // Extension code below here

// // Optional ?
// window.Alpine = Alpine

// Alpine.start()

// import './navbar.js';
// import './dropdown-menu.js';
// import './dropdown-mobile-menu.js'


